import React from "react";
import { UseQueryResult } from "@tanstack/react-query";
import { Loading } from "components/panels";
import { SomethingUnexpectedHappenedMessageBox } from "components/MessageBox/SomethingUnexpectedHappenedMessageBox";
import NoBankAccountsMessageBox from "components/MessageBox/NoBankAccountsMessageBox";
import BankAccountDropdown from "components/dropdowns/reactselect/BankAccountDropdown";

interface Props {
  bankAccountQuery: UseQueryResult<server.dto.BankAccountSmall[], unknown>
  bookkeepingId: number;
  value: server.dto.BankAccountSmall;
  onChange: (bankAccount: server.dto.BankAccountSmall) => void;
  inPageEditing?: {
    cancel: () => void;
  }
}

export const BankAccountDropdownOrWarning = (props: Props) => {
  const { bankAccountQuery } = props;

  if (bankAccountQuery.isLoading || bankAccountQuery.isFetching) {
    return <Loading />;
  }

  if (bankAccountQuery.isError) {
    return <SomethingUnexpectedHappenedMessageBox />;
  }

  if (!bankAccountQuery.data || bankAccountQuery.data.length === 0) {
    return <NoBankAccountsMessageBox type="info" />;
  }

  const isInPageEditing = Boolean(props.inPageEditing);

  return (
    <BankAccountDropdown
      options={bankAccountQuery.data}
      filterByBookkeepingId={props.bookkeepingId}
      value={props.value}
      onChange={props.onChange}
      config={{
        focusOnMount: isInPageEditing,
        openMenuOnFocus: isInPageEditing,
        validatorKey: isInPageEditing ? undefined : "bankAccount",
      }}
      onEsc={props.inPageEditing?.cancel}
    />
  );
};
